import { render, staticRenderFns } from "./zztlzyjsxy.vue?vue&type=template&id=d52be458&scoped=true&"
import script from "./zztlzyjsxy.vue?vue&type=script&lang=js&"
export * from "./zztlzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./zztlzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./zztlzyjsxy.vue?vue&type=style&index=1&id=d52be458&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52be458",
  null
  
)

export default component.exports